import logo from "./logo.svg";
import "./App.css";
import Home from "./pages/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CropProduction from "./pages/Services/CropProduction";
import ShoeProduction from "./pages/Services/ShoeProduction";
import Services from "./pages/Services";
import Director from "./pages/Directors/Director";
import Board from "./pages/Board";
import Gallerys from "./pages/Gallerys";
import AboutPage from "./pages/AboutPage";


function App() {
  return (
    <BrowserRouter>
      <div className="Appss">
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/crop" element={<CropProduction />} />
          <Route path="/shoe" element={<ShoeProduction />} />
          <Route path="/service" element={<Services />} />
          <Route path="/director" element={<Director />} />
          <Route path="/board" element={<Board />} />
          <Route path="/gallery" element={<Gallerys/>} />
          <Route path="/about" element={<AboutPage/>} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
